import { FormGroup, FormArray } from '@angular/forms';
import { DatePipe } from '@angular/common';


export function compareFormValuesFromUtil(fields: string[], initialFormValue: any, updatedFormValue: any, skipFieldsForCheckForm: string[] = [], dateFormFields: any): string[] {
    const changedControls: string[] = [];
    const datePipe = new DatePipe('en-US'); // Adjust locale if needed
    for (let key of fields) {
        if (skipFieldsForCheckForm.includes(key)) continue;
        let initialValue = getNestedValue(initialFormValue, key);
        let updatedValue = getNestedValue(updatedFormValue, key);
        // Special handling for 'dob' field: Convert string to Date
        if (dateFormFields.some(field => key.endsWith(field))) {
            initialValue = datePipe.transform(initialValue, 'yyyy-MM-dd');
            updatedValue = datePipe.transform(updatedValue, 'yyyy-MM-dd');
        }
        // Special case for FormArray: Check length mismatch
        if (Array.isArray(initialValue) && Array.isArray(updatedValue)) {
            if (initialValue.length !== updatedValue.length) {
                changedControls.push(key);
                continue;
            }
            // Check for reorder or element changes
            const isArrayReordered = !initialValue.every((item, index) => {
                if (typeof item === 'object' && item !== null) {
                    // Deep comparison for objects
                    return JSON.stringify(item) === JSON.stringify(updatedValue[index]);
                }
                // Direct comparison for primitive values
                return item === updatedValue[index];
            });
            if (isArrayReordered) {
                changedControls.push(key);
            }
            continue; // Skip further checks for FormArray fields
        }
        // Special case: Remove HTML tags for 'remarks' and 'summary' fields
        if (key === 'remarks' || key === 'summary' || key === 'cand_eligibility' || key === 'keyresponsibilities' || key === 'reqpurpose') {
            initialValue = initialValue?.replace(/<[^>]*>?/gm, '');
            updatedValue = updatedValue?.replace(/<[^>]*>?/gm, '');
        }
        // Convert string numbers to actual numbers
        if (typeof initialValue === 'number' && typeof updatedValue === 'string' || typeof initialValue === 'string' && typeof updatedValue === 'number') {
            updatedValue = Number(updatedValue);
        }
        // Handle null/undefined or empty string cases
        if ((initialValue === null && updatedValue === '') || (initialValue === null && updatedValue === null) || (initialValue === '' && updatedValue === null)) {
            continue;
        }
        // Check for differences in values
        if (initialValue instanceof Date && updatedValue instanceof Date) {
            if (initialValue.getTime() !== updatedValue.getTime()) {
                changedControls.push(key);
            }
        } else if (initialValue !== updatedValue) {
            changedControls.push(key);
        }
    }
    return changedControls;
}

export function getDirtyFieldsFromUtil(formGroup: FormGroup | FormArray, initialFormValue: any, parentKey: string = ''): string[] {
    const dirtyFields: string[] = [];
    for (const key of Object.keys(formGroup.controls)) {
        const control = formGroup.get(key);
        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        if (!control) continue;
        if (control instanceof FormGroup || control instanceof FormArray) {
            if (control instanceof FormArray) {
                const initialArray = getNestedValue(initialFormValue, fullKey) || [];
                // const currentArray = getNestedValue(fromValue, fullKey) || [];
                const currentArray = control.value || [];
                // Mark the FormArray as dirty if the lengths mismatch
                if (initialArray.length !== currentArray.length) {
                    dirtyFields.push(fullKey);
                    continue; // Skip further checks for this FormArray
                }
            }
            // Recursively check nested controls
            const nestedDirtyFields = getDirtyFieldsFromUtil(control, initialFormValue, fullKey);
            if (nestedDirtyFields.length > 0) {
                dirtyFields.push(...nestedDirtyFields);
            }
        } else if (control.dirty) {
            dirtyFields.push(fullKey);
        }
    }
    return dirtyFields;
}

// Utility function to get nested values
export function getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, i) => (o ? o[i.replace(/\[\d+\]/g, (match) => match.slice(1, -1))] : null), obj);
}
